// extracted by mini-css-extract-plugin
module.exports = {"generalButton":"index_generalButton__3fr3t","activation":"index_activation__bZWW8","unactivation":"index_unactivation__3s7De","grayType":"index_grayType__2SNny"};